import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

// Lucide React
import { 
  DollarSign, Users, CreditCard, BarChart3
} from 'lucide-react';

// Phosphor Icons
import { 
  CurrencyDollar, UsersThree, CreditCard as PhosphorCreditCard, ChartBar
} from 'phosphor-react';

// Heroicons
import { 
  CurrencyDollarIcon, UsersIcon, CreditCardIcon, ChartBarIcon
} from '@heroicons/react/24/outline';

import {
  CurrencyDollarIcon as CurrencyDollarSolid, UsersIcon as UsersSolid, 
  ArrowTrendingUpIcon as TrendingSolid, CreditCardIcon as CreditCardSolid
} from '@heroicons/react/24/solid';

export default function MetricIconsDemo() {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-7xl mx-auto space-y-8">
        <div>
          <h1 className="text-4xl font-bold mb-2">Ícones dos Componentes</h1>
          <p className="text-muted-foreground">
            Comparação visual dos ícones que aparecem nos cards do dashboard
          </p>
        </div>

        {/* Estilo Atual - Emoji */}
        <Card>
          <CardHeader>
            <CardTitle>1. Estilo Atual - Emoji</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Total de Vendas</p>
                      <p className="text-3xl font-bold">R$ 125.430,00</p>
                      <p className="text-sm text-green-500 mt-2">↑ 12.5%</p>
                    </div>
                    <span className="text-4xl">💰</span>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Novos Clientes</p>
                      <p className="text-3xl font-bold">342</p>
                      <p className="text-sm text-green-500 mt-2">↑ 8.2%</p>
                    </div>
                    <span className="text-4xl">👥</span>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Taxa de Conversão</p>
                      <p className="text-3xl font-bold">3.24%</p>
                      <p className="text-sm text-red-500 mt-2">↓ 2.1%</p>
                    </div>
                    <span className="text-4xl">📊</span>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Ticket Médio</p>
                      <p className="text-3xl font-bold">R$ 367,00</p>
                      <p className="text-sm text-green-500 mt-2">↑ 5.4%</p>
                    </div>
                    <span className="text-4xl">💳</span>
                  </div>
                </CardContent>
              </Card>
            </div>
          </CardContent>
        </Card>

        {/* Lucide React - Regular */}
        <Card>
          <CardHeader>
            <CardTitle>2. Lucide React - Regular</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Total de Vendas</p>
                      <p className="text-3xl font-bold">R$ 125.430,00</p>
                      <p className="text-sm text-green-500 mt-2">↑ 12.5%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <DollarSign className="w-8 h-8 text-primary" strokeWidth={2} />
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Novos Clientes</p>
                      <p className="text-3xl font-bold">342</p>
                      <p className="text-sm text-green-500 mt-2">↑ 8.2%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <Users className="w-8 h-8 text-primary" strokeWidth={2} />
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Taxa de Conversão</p>
                      <p className="text-3xl font-bold">3.24%</p>
                      <p className="text-sm text-red-500 mt-2">↓ 2.1%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <BarChart3 className="w-8 h-8 text-primary" strokeWidth={2} />
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Ticket Médio</p>
                      <p className="text-3xl font-bold">R$ 367,00</p>
                      <p className="text-sm text-green-500 mt-2">↑ 5.4%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <CreditCard className="w-8 h-8 text-primary" strokeWidth={2} />
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </CardContent>
        </Card>

        {/* Lucide React - Thin */}
        <Card>
          <CardHeader>
            <CardTitle>3. Lucide React - Thin (Mais Moderno)</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Total de Vendas</p>
                      <p className="text-3xl font-bold">R$ 125.430,00</p>
                      <p className="text-sm text-green-500 mt-2">↑ 12.5%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <DollarSign className="w-8 h-8 text-primary" strokeWidth={1.5} />
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Novos Clientes</p>
                      <p className="text-3xl font-bold">342</p>
                      <p className="text-sm text-green-500 mt-2">↑ 8.2%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <Users className="w-8 h-8 text-primary" strokeWidth={1.5} />
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Taxa de Conversão</p>
                      <p className="text-3xl font-bold">3.24%</p>
                      <p className="text-sm text-red-500 mt-2">↓ 2.1%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <BarChart3 className="w-8 h-8 text-primary" strokeWidth={1.5} />
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Ticket Médio</p>
                      <p className="text-3xl font-bold">R$ 367,00</p>
                      <p className="text-sm text-green-500 mt-2">↑ 5.4%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <CreditCard className="w-8 h-8 text-primary" strokeWidth={1.5} />
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </CardContent>
        </Card>

        {/* Phosphor Icons - Light */}
        <Card>
          <CardHeader>
            <CardTitle>4. Phosphor Icons - Light (Minimalista)</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Total de Vendas</p>
                      <p className="text-3xl font-bold">R$ 125.430,00</p>
                      <p className="text-sm text-green-500 mt-2">↑ 12.5%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <CurrencyDollar size={32} weight="light" className="text-primary" />
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Novos Clientes</p>
                      <p className="text-3xl font-bold">342</p>
                      <p className="text-sm text-green-500 mt-2">↑ 8.2%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <UsersThree size={32} weight="light" className="text-primary" />
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Taxa de Conversão</p>
                      <p className="text-3xl font-bold">3.24%</p>
                      <p className="text-sm text-red-500 mt-2">↓ 2.1%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <ChartBar size={32} weight="light" className="text-primary" />
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Ticket Médio</p>
                      <p className="text-3xl font-bold">R$ 367,00</p>
                      <p className="text-sm text-green-500 mt-2">↑ 5.4%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <PhosphorCreditCard size={32} weight="light" className="text-primary" />
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </CardContent>
        </Card>

        {/* Phosphor Icons - Duotone */}
        <Card>
          <CardHeader>
            <CardTitle>5. Phosphor Icons - Duotone (Sofisticado)</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Total de Vendas</p>
                      <p className="text-3xl font-bold">R$ 125.430,00</p>
                      <p className="text-sm text-green-500 mt-2">↑ 12.5%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <CurrencyDollar size={32} weight="duotone" className="text-primary" />
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Novos Clientes</p>
                      <p className="text-3xl font-bold">342</p>
                      <p className="text-sm text-green-500 mt-2">↑ 8.2%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <UsersThree size={32} weight="duotone" className="text-primary" />
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Taxa de Conversão</p>
                      <p className="text-3xl font-bold">3.24%</p>
                      <p className="text-sm text-red-500 mt-2">↓ 2.1%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <ChartBar size={32} weight="duotone" className="text-primary" />
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Ticket Médio</p>
                      <p className="text-3xl font-bold">R$ 367,00</p>
                      <p className="text-sm text-green-500 mt-2">↑ 5.4%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <PhosphorCreditCard size={32} weight="duotone" className="text-primary" />
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </CardContent>
        </Card>

        {/* Heroicons - Outline */}
        <Card>
          <CardHeader>
            <CardTitle>6. Heroicons - Outline (Clean)</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Total de Vendas</p>
                      <p className="text-3xl font-bold">R$ 125.430,00</p>
                      <p className="text-sm text-green-500 mt-2">↑ 12.5%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <CurrencyDollarIcon className="w-8 h-8 text-primary" />
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Novos Clientes</p>
                      <p className="text-3xl font-bold">342</p>
                      <p className="text-sm text-green-500 mt-2">↑ 8.2%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <UsersIcon className="w-8 h-8 text-primary" />
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Taxa de Conversão</p>
                      <p className="text-3xl font-bold">3.24%</p>
                      <p className="text-sm text-red-500 mt-2">↓ 2.1%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <ChartBarIcon className="w-8 h-8 text-primary" />
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Ticket Médio</p>
                      <p className="text-3xl font-bold">R$ 367,00</p>
                      <p className="text-sm text-green-500 mt-2">↑ 5.4%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <CreditCardIcon className="w-8 h-8 text-primary" />
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </CardContent>
        </Card>

        {/* Heroicons - Solid */}
        <Card>
          <CardHeader>
            <CardTitle>7. Heroicons - Solid (Impactante)</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Total de Vendas</p>
                      <p className="text-3xl font-bold">R$ 125.430,00</p>
                      <p className="text-sm text-green-500 mt-2">↑ 12.5%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <CurrencyDollarSolid className="w-8 h-8 text-primary" />
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Novos Clientes</p>
                      <p className="text-3xl font-bold">342</p>
                      <p className="text-sm text-green-500 mt-2">↑ 8.2%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <UsersSolid className="w-8 h-8 text-primary" />
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Taxa de Conversão</p>
                      <p className="text-3xl font-bold">3.24%</p>
                      <p className="text-sm text-red-500 mt-2">↓ 2.1%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <TrendingSolid className="w-8 h-8 text-primary" />
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-2">
                <CardContent className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-muted-foreground mb-1">Ticket Médio</p>
                      <p className="text-3xl font-bold">R$ 367,00</p>
                      <p className="text-sm text-green-500 mt-2">↑ 5.4%</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <CreditCardSolid className="w-8 h-8 text-primary" />
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
